module.exports = __webpack_public_path__ + "static/img/case_banner_12.47ce796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_12.png
// module id = JjlA
// module chunks = 34